import React from "react";
import { assetsPath } from "../../../../../utils";

const baseAssetUrl = assetsPath("laguna-seaside-residences");

export default ({ currentLang, selectedType, selectedBuilding }) => {
  const BG = `${baseAssetUrl}/images/site-plan/${currentLang}/1.png`;
  const shouldDisplay = (build, type) => {
    return (selectedType === type || selectedType === "all") &&
      (selectedBuilding === build || selectedBuilding === "all")
      ? "opacity-in"
      : "opacity-out";
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 500"
      data-name="Layer 1"
      className="site-plan-svg"
      height="500px"
      width="500px"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g className="building-a">
          <g id="2-bed" data-name="1_2" className={shouldDisplay("a", "2-bed")}>
            <polygon
              points="624.52 275.62 556.04 275.79 556.04 217.46 624.06 217.46 624.52 275.62"
              opacity="0.8"
            />
          </g>
          <g id="3-bed" data-name="1_3" className={shouldDisplay("a", "3-bed")}>
            <rect
              x="625.93"
              y="216.21"
              width="89.43"
              height="59.52"
              opacity="0.8"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/LagunaSeasideResidences/sitePlan/svg/floor/1.js